export const ROLE = {
	admin: "admin",
	user: "user",
};
